import ViewerMethod from "../../core/ViewerMethod";
import { makeReducer } from "../../core/make-reducer";

const addId = (data) =>
  data.map((toc, i) => ({ ...toc, uuid: `tocIndex${i}` }));
const toc = makeReducer(ViewerMethod.GET_TOC, addId, []);

export default toc;
